import { useEffect, useState } from 'react';

/**
 * Delays a value so typing does not fire a request per keystroke. Used for the search box, where
 * every character would otherwise be a full-text query.
 */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
